module.exports = __webpack_public_path__ + "img/hamburger_icon.160a94f1.svg";